export enum Urls {
  Host = 'host',
  AuthTokenGenerator = 'auth_token_generator',
  EmailValidator = 'email_validator_url',
  PhoneValidator = 'phone_validator_url',
  ApiBase = 'api_base_url',
  ComparisonsApi = 'comparisons_api_url',
  LookupApi = 'lookup_api_url',
  ContentApi = 'content_api_url',
  DealerPagesApi = 'dealer_pages_api_url',
}
export enum FeatureFlags {
  Auth = 'auth_enabled',
  PriceFeedback = 'price_feedback_enabled',
}
export enum Toggles {
  DebugEvents = 'debug_events',
  TestAds = 'test_ads',
}
